import React from 'react';
import { Link } from 'react-router-dom';

const SimpleNav = () => {
  return (
    <div className="fixed top-4 right-4 z-50">
      <div className="flex space-x-3">
        <Link 
          to="/" 
          className="bg-[#D2B48C] text-gray-800 hover:bg-[#C4A77D] px-4 py-2 rounded-full text-sm font-medium transition duration-150 ease-in-out shadow-md"
        >
          Home
        </Link>
        <Link 
          to="/scanner" 
          className="bg-[#D2B48C] text-gray-800 hover:bg-[#C4A77D] px-4 py-2 rounded-full text-sm font-medium transition duration-150 ease-in-out shadow-md"
        >
          Scan QR
        </Link>
      </div>
    </div>
  );
};

export default SimpleNav; 